import { AirtableIcon } from '../../../assets/icons/airtable';
import { createEmbedProvider } from '../factory';

/**
 * Airtable URL regex pattern
 * Matches: airtable.com/shrXXX or airtable.com/embed/shrXXX
 * Captures the share ID (starting with shr) in group 1.
 */
export const AIRTABLE_REGEX = /^https:\/\/airtable\.com\/(?:embed\/)?(shr[^/?#]+)/;

export const airtableProvider = createEmbedProvider({
  id: 'airtable',
  label: 'Airtable',
  icon: <AirtableIcon className="size-5" />,
  regex: AIRTABLE_REGEX,
  buildEmbedUrl: (match) => `https://airtable.com/embed/${match[1]}`,
});
